// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_WONiT {
  height: 100%;
  max-height: 100vh;
}

.saleInformationContent_Aepoj {
  height : 756px;
}

.customerAccountContent_FJYQ7 {
  height: 910px;
}

.confirmScreenContent_xeI9c {
  height: 100vh;
}

.saleErrorContent_LY9ks {
  height: 512px;
}

.downloadPDFContent_exP7Y {
  min-height: 204px !important;
}

@media only screen and (max-width: 1023px) {
  .content_WONiT {
    height: 100vh;
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/salesFlow/flows/RecovrAndVehicle.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".content {\n  height: 100%;\n  max-height: 100vh;\n}\n\n.saleInformationContent {\n  height : 756px;\n}\n\n.customerAccountContent {\n  height: 910px;\n}\n\n.confirmScreenContent {\n  height: 100vh;\n}\n\n.saleErrorContent {\n  height: 512px;\n}\n\n.downloadPDFContent {\n  min-height: 204px !important;\n}\n\n@media only screen and (max-width: 1023px) {\n  .content {\n    height: 100vh;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_WONiT`,
	"saleInformationContent": `saleInformationContent_Aepoj`,
	"customerAccountContent": `customerAccountContent_FJYQ7`,
	"confirmScreenContent": `confirmScreenContent_xeI9c`,
	"saleErrorContent": `saleErrorContent_LY9ks`,
	"downloadPDFContent": `downloadPDFContent_exP7Y`
};
export default ___CSS_LOADER_EXPORT___;
